import { MOST_REQUESTED_SERVICES } from './mostRequestedServices';

export const normalizeText = (value) => String(value || '').toLowerCase().trim();

export const buildServiceSearchText = (service = {}) => {
  return normalizeText(`${service?.title || ''} ${service?.name || ''} ${service?.id || ''}`);
};

export const resolveServiceCatalogEntry = (service = {}) => {
  const searchText = buildServiceSearchText(service);

  return MOST_REQUESTED_SERVICES.find((item) => {
    const aliasPool = [item.title, ...(item.aliases || [])]
      .map((entry) => normalizeText(entry))
      .filter(Boolean);

    return aliasPool.some((entry) => searchText.includes(entry));
  }) || null;
};
